import { UserSettingChangeEmailPage } from "@/features/user-setting/pages/UserSettingChangeEmail";

const UserSettingChangeEmail = () => {

  return <UserSettingChangeEmailPage />;
};

export default UserSettingChangeEmail;
